<template>
    <div class="media align-items-center">
        <app-avatar :title="rowData.name"
                    avatar-class="avatars-w-50"
                    :img="$optional(rowData, 'logo')"
                    :alt-text="rowData.name"/>
        <div class="media-body ml-3">
            <a v-if="rowData.name" href="#" class="text-muted">{{ rowData.name }}</a><br>
            <a href="#" class="text-muted" v-if="$optional(rowData.sub_categories, 'length')">
                Total sub categories: {{ $optional(rowData.sub_categories, 'length') }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CategoryMedia",
        props: {
            value: {},
            rowData: {},
            index: {},
        },
    }
</script>

<style scoped>

</style>